import {
  ApplicationRef,
  Directive,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import {PortalSlotService} from "./portal-slot.service";
import {Subscription} from "rxjs";

@Directive({
  selector: '[int-portal], [intPortal]',
  providers: [
    PortalSlotService
  ]
})
export class PortalSlotDirective implements OnInit, OnDestroy {

  portalStream$!: Subscription;

  constructor(
    public containerRef: ApplicationRef,
    public viewContainerRef: ViewContainerRef,
    public portalService: PortalSlotService
  ) { }

  get getServiceInstance(): PortalSlotService {
    return this.portalService;
  }

  ngOnInit(): void {
    this.portalService.containerRef = this.viewContainerRef;
    this.portalStream$ = this.portalService.components$
      .subscribe((components) => {
        this.viewContainerRef.clear();
        components.forEach((component) => {
          this.viewContainerRef.createEmbeddedView(component.component, {$implicit: component.payload});
        })
      });
  }

  ngOnDestroy() {
    this.portalStream$.unsubscribe();
  }

}
